var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 24,
    fill: "#FF8429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.082 46C24.3876 46 23.7973 45.7569 23.3112 45.2708C22.8251 44.7847 22.582 44.1944 22.582 43.5V25.6667C22.582 25.3611 22.6445 25.0556 22.7695 24.75C22.8945 24.4444 23.0681 24.1806 23.2904 23.9583L31.9154 14.875C32.3043 14.4861 32.7695 14.25 33.3112 14.1667C33.8529 14.0833 34.3598 14.1806 34.832 14.4583C35.3043 14.7361 35.6584 15.125 35.8945 15.625C36.1306 16.125 36.1931 16.6389 36.082 17.1667L34.4987 24.6667H47.832C48.4709 24.6667 49.0473 24.9236 49.5612 25.4375C50.0751 25.9514 50.332 26.5278 50.332 27.1667V30.5833C50.332 30.8889 50.2973 31.2431 50.2279 31.6458C50.1584 32.0486 50.0543 32.4028 49.9154 32.7083L45.082 43.875C44.832 44.4583 44.4223 44.9583 43.8529 45.375C43.2834 45.7917 42.6793 46 42.0404 46H25.082ZM17.707 46C17.0681 46 16.5126 45.7639 16.0404 45.2917C15.5681 44.8194 15.332 44.2639 15.332 43.625V27.0417C15.332 26.4028 15.5681 25.8472 16.0404 25.375C16.5126 24.9028 17.0681 24.6667 17.707 24.6667C18.3459 24.6667 18.9015 24.9028 19.3737 25.375C19.8459 25.8472 20.082 26.4028 20.082 27.0417V43.625C20.082 44.2639 19.8459 44.8194 19.3737 45.2917C18.9015 45.7639 18.3459 46 17.707 46Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbIcon);
export default __webpack_public_path__ + "static/media/thumb-icon.2b72cc202794e4028f82b05295aee6ec.svg";
export { ForwardRef as ReactComponent };